import { render } from "./App.vue?vue&type=template&id=09b31b5c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=09b31b5c&lang=css"

import exportComponent from "C:\\FrontEnd\\JelentkezesiRendszer\\jelentkezesirendszer_frontend_user\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__